import { Link } from "@tblabs/truffle";
import { Box } from "../Utils/Box";


export class NavBarRight extends Box
{
    constructor(menu: Record<string, string>)
    {
        super("navbar__menu", [
            new Box("navbar__links", [
                ...Object.entries(menu).map(([key, value]) => new Link(key, "#" + value).Class("navbar__link")),
            ]),
        ]);
    }
}
